import { useContext, useMemo } from 'react'

import EntitiesSelector from './EntitiesSelector'
import { GlobalContext } from '../../../Providers/GlobalProvider'

const SpecialitiesSelector = ({ className = '', empty = false, disabled, multiple = 'default', reverse = false, style = {}, values = [], dropdownRender, onChange }) => {
  const { specialities } = useContext(GlobalContext)

  const entityOptions = useMemo(() => specialities.map(ss => {
    return { value: ss.id, entity: ss, label: ss.name, tooltip: ss.name }
  }), [specialities, reverse])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={entityOptions}
      multiple={multiple}
      showSearch
      style={style}
      values={values}
      onChange={onChange}
      empty={empty}
    />
  )
}

export default SpecialitiesSelector
